const BarsIcon = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H18V2H0V0ZM0 5H18V7H0V5ZM0 10H18V12H0V10Z" fill="#BDBDBD" />
  </svg>
);

const ChevronIcon = () => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon-chevron-down"
  >
    <path
      d="M12.355 0L7 5.50657L1.645 0L0 1.69526L7 8.90909L14 1.69526L12.355 0Z"
      fill="#BDBDBD"
    />
  </svg>
);

const ExportIcon = () => (
  <svg
    width="16"
    height="22"
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon-export"
  >
    <path
      d="M8 -3.49691e-07L4 4L7 4L7 13L9 13L9 4L12 4M14 22L2 22C0.89 22 -3.93402e-08 21.1 -8.74228e-08 20L-6.11959e-07 8C-6.35145e-07 7.46957 0.210713 6.96086 0.585786 6.58579C0.960858 6.21071 1.46957 6 2 6L5 6L5 8L2 8L2 20L14 20L14 8L11 8L11 6L14 6C14.5304 6 15.0391 6.21071 15.4142 6.58579C15.7893 6.96086 16 7.46957 16 8L16 20C16 20.5304 15.7893 21.0391 15.4142 21.4142C15.0391 21.7893 14.5304 22 14 22Z"
      fill="#2F80ED"
    />
  </svg>
);

export { BarsIcon, ChevronIcon, ExportIcon };
